<template>
  <nav class="navigation">
    <a href="#" v-scroll-to="'#section1'">Wat is de heldengame?</a>
    <a href="#" v-scroll-to="'#section3'">Hoe werkt het?</a>
    <a href="#" v-scroll-to="'#section4-top'">Wat moet je doen?</a>
    <a href="#" v-scroll-to="'#section4-bottom'">Speel de game!</a>
    <a href="#" v-scroll-to="'#section5'">Vragen?</a>
  </nav>
</template>

<script>
export default {
  name: 'Navigation'
}
</script>

<style scoped lang="scss">
.navigation {
  height: 6.0rem;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding-right: 3rem;

  a {
    display: inline-block;
    padding: 1.5rem;
    padding-bottom: 0.9rem;
    font-size: 2.1rem;
    font-weight: 400;
    line-height: 1;
    text-decoration: none;
    text-transform: uppercase;
    transition: color 200ms;
    color: $color-black;

    &:hover {
      color: $color-green;
    }

    @include breakpoint(min-width, $screen-hd) {
      font-size: 2.4rem;
    }
  }
}
</style>
